import {
  Stack,
  Paper,
  Grid,
  Typography,
  OutlinedInput,
  TextareaAutosize,
  IconButton,
  Button,
  InputAdornment,
} from "@mui/material";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import DynamicAttachmentView from "../../UI/DynamicAttachmentView";
import QuotationSummary from "./QuotationSummary";
import StandardSummary from "./StandardSummary";

const ServiceBookingForm = ({
  inputField,
  setInputField,
  bookInfo,
  setBookInfo,
  quantity,
  setQuantity,
  serviceDetails,
  user,
  localData,
  navigate,
  setGetRefer,
  setCurrentAmount,
  setCurrentCurrency,
  setPaymentInfo,
  handleClick,
  handleOpen2,
  userParams,
  userTypeInfo,
  // fileRefer,
  // setFileRefer,
  // attachmentList,
  // setAttachmentList,
  // setGcTagList,
}) => {
  const { refer } = useParams();
  const isQuotation = userParams === "quotation";
const [fileRefer, setFileRefer] = useState(null);
        const [attachmentList, setAttachmentList] = useState([]);
        const [imageList, setImageList] = useState([]);
        const [gcTagList, setGcTagList] = useState([]);
        const [videoList, setVideoList] = useState([]);
  const service = serviceDetails?.[0] || {};
  const unitPrice = isQuotation ? parseFloat(bookInfo?.advance || 0) : parseFloat(service?.price || 0);
  const subtotal = Math.round(quantity * unitPrice);
  const gatewayCharge = Math.round(subtotal * 0.018);
  const totalAmount = subtotal + gatewayCharge;

  const currencySymbol =
    service.currency === 2 ? "USD" : service.currency === 3 ? "AED" : "BDT";

  const handleSubmit = () => {
    const formData = new FormData();
    const sopnoId = user?.sopnoid;
    const currency = service?.currency;

    const updatedBookInfo = {
      ...bookInfo,
      sopnoId,
      quantity,
      currency,
      subtotal,
      gatewayCharge,
      totalAmount,
      fileRefer,
    };

    const serviceInfo = {
      service_refer: service?.sRefer,
      service_poster: service?.poster,
      agency_refer: service?.c_refer,
    };

    formData.append("bookInfo", JSON.stringify(updatedBookInfo));
    formData.append("serviceInfo", JSON.stringify(serviceInfo));
    formData.append("poster", user?.sopnoid);
    formData.append("cRefer", user?.c_refer);

    if (isQuotation) {
      // Attach quotation-specific fields
      const quotationInfo = {
        title: service?.title,
        category: service?.jcategory,
        details: service?.details,
        start_date: bookInfo?.start_date,
        delivery_date: bookInfo?.delivery_date,
        message: bookInfo?.message,
        fileRefer: fileRefer,
      };

      formData.append("quotation_Info", JSON.stringify(quotationInfo));
      formData.append("quotation_attachment", []);
    //   formData.append("quotation_attachment", JSON.stringify(attachmentList));
    }

    const url = isQuotation
      ? "https://aps.songjukti.com/profile/login/api_booking/gh_user_serviceBookNew.php"
      : "https://aps.songjukti.com/profile/login/api_booking/gh_user_new_Book.php";

    fetch(url, { method: "POST", body: formData })
      .then((res) => res.json())
      .then((result) => {
        if (result?.m_type === "success" && result?.pay_amount?.default) {
          handleClick();
          setGetRefer(result?.get_refer);
          setCurrentAmount(Math.ceil(result?.pay_amount?.default));
          setCurrentCurrency(result?.currency ?? 1);
          setPaymentInfo(result?.pay_amount);
          handleOpen2();
        }
      })
      .catch((error) => console.log("ServiceApiError:", error));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    const isValid = /[0-9a-zA-Z]/.test(value);

    setInputField((prev) => ({
      ...prev,
      [name]: isValid ? value : "",
      fieldErrorAlert: isValid ? "" : name,
    }));

    setBookInfo((prev) => ({ ...prev, [name]: isValid ? value : "" }));
  };

  const increaseQty = () => setQuantity((prev) => prev + 1);
  const decreaseQty = () => setQuantity((prev) => (prev > 1 ? prev - 1 : 1));

  return (
    <Stack spacing={2} sx={{ padding: "10px" }}>
      {/* FORM FIELDS */}
      <Paper sx={{ padding: "20px", mt: 0 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Typography fontSize="12pt">Service Start Date</Typography>
            <OutlinedInput
              name="start_date"
              size="small"
              type="date"
              fullWidth
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography fontSize="12pt">Expected Delivery Date</Typography>
            <OutlinedInput
              name="delivery_date"
              size="small"
              type="date"
              fullWidth
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12}>
            <Stack spacing={0.5}>
                                <Typography variant="p" sx={{ fontSize: "12pt" }}>
                                  Message
                                </Typography>
                                <TextareaAutosize
                                  aria-label="minimum height"
                                  minRows={3}
                                  placeholder="Enter Details"
                                  name="message"
                                  className="customTextField"
                                  style={{
                                    fontSize: "11pt",
                                    fontFamily: `-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, "Oxygen",
                                  Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue,
                                  sans-serif`,
                                    width: "100%",
                                    maxWidth: "100%",
                                    boxSizing: "border-box",
                                    border: "1px solid #c8c9cb",
                                    borderRadius: "4px",
                                    paddingLeft: "15px",
                                    paddingRight: "15px",
                                    paddingTop: "10px",
                                  }}
                                  onChange={handleChange}
                                />
                              </Stack>
          </Grid>

          {isQuotation && (
            <Grid item xs={12}>
              <Typography fontSize="11pt" fontWeight={500}>
                Attachment (PDF/DOC - Max 2)
              </Typography>

              <DynamicAttachmentView
                label=""
                itemPicName="proposalAttach"
                itemType="new"
                MAX_FILE_SIZE_MB={5}
                MAX_FILES={2}
                user={user}
                croom={fileRefer}
                fileRefer={fileRefer}
                setFileRefer={setFileRefer}
                attachmentList={attachmentList}
                setAttachmentList={setAttachmentList}
                allowedTypes={[
                  "application/pdf",
                  "application/x-zip-compressed",
                  "application/postscript",
                  "text/plain",
                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  "video/mp4",
                ]}
                onGcTag={(gc_tag) => setGcTagList((prev) => [...prev, gc_tag])}
              />

              <Typography variant="body2" sx={{ pt: 1 }}>
                Attach up to 2 files under 10 MB each. Include work samples or supporting documents.
              </Typography>
            </Grid>
          )}
        </Grid>
      </Paper>

      {/* SUMMARY SECTION */}
      {isQuotation ? (
        <QuotationSummary
          quantity={quantity}
          currencySymbol={currencySymbol}
          bookInfo={bookInfo}
          onAdd={increaseQty}
          onReduce={decreaseQty}
          handleChange={handleChange}
        />
      ) : (
        <StandardSummary
          quantity={quantity}
          unitPrice={unitPrice}
          subtotal={subtotal}
          gatewayCharge={gatewayCharge}
          total={totalAmount}
          currencySymbol={currencySymbol}
          onAdd={increaseQty}
          onReduce={decreaseQty}
        />
      )}

      {/* ACTION BUTTONS */}
      <Stack direction="row" justifyContent="flex-end" spacing={2}>
        <Button
          variant="outlined"
          color="success"
          size="small"
          sx={{ textTransform: "capitalize", fontSize: "11pt", borderRadius: "30px" }}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>

        <Button
          variant="contained"
          color="success"
          size="small"
          disabled={
            !inputField?.message || !inputField?.start_date || !inputField?.delivery_date
          }
          sx={{ textTransform: "capitalize", fontSize: "11pt", borderRadius: "30px" }}
          onClick={handleSubmit}
        >
          Send Request
        </Button>
      </Stack>
    </Stack>
  );
};

export default ServiceBookingForm;

